import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Select from "react-select";
import "rc-slider/assets/index.css";
import { fonts, font_sizes, style } from "../../../constants/constants";
import { setFontSize, setFont } from "../../../store/actions/image";

// Text font options
const FontOption = ({ element, attribute }) => {
  const dispatch = useDispatch();
  const canvas = useSelector(({ image }) => image.canvas);
  const textChanged = useSelector(({ image }) => image.textChanged);
  const changeFontSize = (val) => {
    dispatch(setFontSize(element.id, val.value));
  };
  const changeFont = (val) => {
    dispatch(setFont(element.id, val.value));
  };
  if (!canvas) {
    return "";
  }
  const item = canvas.getObjects().find((f) => f.id === element.id);
  if (!item) {
    return "";
  }
  return (
    <Select
      menuPortalTarget={document.body}
      options={attribute === "font" ? fonts : font_sizes}
      value={{
        label: attribute === "font" ? item.fontFamily : item.fontSize,
        value: null,
      }}
      styles={style}
      onChange={attribute === "font" ? changeFont : changeFontSize}
      placeholder="Select font"
    />
  );
};

export default FontOption;
